import React from 'react';

import './index.scss';

const HorizontalRule = () => {
  return <hr className="ndx-HorizontalRule" />;
};
HorizontalRule.displayName = 'HorizontalRule';

export default HorizontalRule;
